import { render, staticRenderFns } from "./ClientSales.vue?vue&type=template&id=ad11acfe&scoped=true"
import script from "./ClientSales.vue?vue&type=script&lang=js"
export * from "./ClientSales.vue?vue&type=script&lang=js"
import style0 from "./ClientSales.vue?vue&type=style&index=0&id=ad11acfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad11acfe",
  null
  
)

export default component.exports